import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface OneStepCheckoutStyles {
  oneStepCheckoutContainer: Styles
  oneStepCheckoutHeader: Styles
  paymentMethodsContainer: Styles
}

interface OneStepCheckoutStyleProps {
  canShowApplePay: boolean
}

export const useStyles = createUseStyles<OneStepCheckoutStyles, OneStepCheckoutStyleProps>((theme) => {
  return {
    oneStepCheckoutContainer: {
      marginTop: theme.calcUnit(theme.spacing.s3),
      marginBottom: theme.calcUnit(theme.spacing.s1),
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      maxWidth: theme.calcUnit(406),
    },
    oneStepCheckoutHeader: {
      padding: '16px 0',
      borderBottom: `${theme.calcUnit(1)} solid ${theme.colors.textFieldBorderColor}`,
      fontFamily: 'Roboto, Sans-seriff',
      fontWeight: 700,
      fontSize: theme.calcUnit(20),
      lineHeight: theme.calcUnit(24),
    },
    paymentMethodsContainer: ({ canShowApplePay }) => ({
      display: 'grid',
      gridTemplateColumns: canShowApplePay ? '1fr 1fr 1fr' : '1fr 1fr',
      gap: theme.spacing.s3,
    }),
  }
})
